import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {destroyMask, formatPhoneNumber, PROFILE_TEXT} from '../helpers/Common';
import $ from "jquery";
class Profile extends Component {

  constructor(props) {
    super(props);
    this.state =
      {
        formData:
        {
          title: 'Mr.',
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          dob: '',
          gender: 'Male',
        },
        first_nameError: '',
        last_nameError: '',
        emailError: '',
        titleError: '',
        phoneError: '',
        dobError: '',
        genderError: '',
        nextStep: 2,
        startDate: '',
      };
    this.submit = this.submit.bind(this);
  }

  handleChange = (e) => {
    let text = 'Please Enter Valid ';
    let errorKey = e.target.name + "Error";
    let formData = this.state.formData;
    var flag = true;

    if (e.target.name === "first_name") {
      const re = /^[a-zA-Z][a-zA-Z\s]*$/;
      if (!re.test(e.target.value)) {
        flag = false;
        this.setState({
          first_nameError: text + this.formatText(e.target.name),
        });
      }
      if (e.target.value.length === 0) {
        this.setState({
          first_nameError: ''
        });
      }
    }

    if (e.target.name === "last_name") {
      const re = /^[a-zA-Z][a-zA-Z\s]*$/;
      if (!re.test(e.target.value)) {
        flag = false;
        this.setState({
          last_nameError: text + this.formatText(e.target.name),
        });
      }
      if (e.target.value.length === 0) {
        this.setState({
          last_nameError: ''
        });
      }
    }

    if(e.target.phone === "phone"){
      const re = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
      if(!re.test(e.target.value)){
        flag = false;
        this.setState({
          phoneError: text + this.formatText(e.target.phone),
        });
      }

      if (e.target.value.length === 0) {
        this.setState({
          phoneError: ''
        });
      }
    }



    if (flag) {
      formData[e.target.name] = e.target.value;
      this.setState({
        formData: formData,
        [errorKey]: ''
      });
    }
  }

  formatText = (text) => {
    text = text.toLowerCase()
      .split('_')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
    return text;
  }

  handleDateChange = (date) => {
    let name = "dob"
    let errorKey = name + "Error";
    let formData = this.state.formData;
    let formattedDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate() + 1)).slice(-2);
    formData[name] = formattedDate;
    this.setState({
      startDate: date,
      formData: formData,
      [errorKey]: ''
    });
  }

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  }

  userProfile = (e) => {
    e.preventDefault();
  }

  componentWillMount() {
    localStorage.setItem('newData','')
    localStorage.setItem('saveQuest','')
    localStorage.setItem('editQuest','')
    localStorage.setItem('allComplains','')
    localStorage.setItem('oldData','')

    $('body').on('input','#phone',null,(event)=>{


      let value =  ( formatPhoneNumber(event.target.value));

      if(value){

        $("#phone").val(value);

      }

      // console.log(value);




    });
  }

  submit = (e) => {
    let submitForm = true;

    // const re = /^\+?([0-9]{1})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
    // // var newString = this.state.formData.phone.replace(/[-\s]/g, '');
    // if (!re.test(this.state.formData.phone)) {
    //   this.setState({
    //     phoneError: 'Please Enter Valid Phone Number',
    //   });
    //   submitForm = false;
    //
    // }

    const re2 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re2.test(this.state.formData.email)) {
      this.setState({
        emailError: 'Please Enter Valid Email Address',
      });
      submitForm = false;
    }

    if (!this.state.formData.title) {
      this.setState({
        titleError: 'Title Is Required'
      });
      submitForm = false;
    }

    if (!this.state.formData.first_name) {
      this.setState({
        first_nameError: 'First Name Is Required'
      });
      submitForm = false;
    }

    if (!this.state.formData.last_name) {
      this.setState({
        last_nameError: 'Last Name Is Required'
      });
      submitForm = false;
    }

    if (!this.state.formData.email) {
      this.setState({
        emailError: 'Email Is Required'
      });
      submitForm = false;
    }
    if (!this.state.formData.phone) {
      this.setState({
        phoneError: 'Phone Is Required'
      });
      submitForm = false;
    }
    if (!this.state.formData.dob) {
      this.setState({
        dobError: 'Date Of Birth Is Required'
      });
      submitForm = false;
    }
    if (!this.state.formData.gender) {
      this.setState({
        genderError: 'Gender Is Required'
      });
      submitForm = false;
    }
    if (this.state.titleError !== '' || this.state.last_nameError !== '' || this.state.first_nameError !== '' || this.state.dobError !== '' || this.state.genderError !== '' || this.state.emailError !== '' || this.state.phoneError !== '') {
      submitForm = false;
    }
    if(this.state.formData.title=="Ms.")
    { 
      let _formData = this.state.formData;
      _formData.gender = 'Female';
      this.setState({
        formData: _formData
      });
    }
    //submitForm = true;
    if (submitForm) {

      this.props.setProfileData(this.state.formData);
      this.props.handleNextPrevSteps(this.state.nextStep);
      // localStorage.setItem('patientProfileData', JSON.stringify(this.state.formData));
      // this.props.history.push('/complain');
    }

  }

  render() {
    return (
      <React.Fragment>
        {/* <Header /> */}
        <section className="c-login profilePage">
          <div className="bg-overlay" style={{
            backgroundImage: "url(" + require("../assets/img/bg/new-login-bg.jpg") + ")",
          }}></div>
          <div className="container">
            <div className="patient-logo">
              <img src={require("../assets/img/icons/ic-login.png")} alt="" />
              <span>{PROFILE_TEXT.Patient_Profile}</span>
            </div>
            <div className="login-form">
              <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-10 col-sm-12">
                  <div className="row">
                    <div className="col-md-2 col-sm-12">
                      <div className={"form-group" + (this.state.titleError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.TITLE}</label>
                        <select className="form-control" name="title" onChange={this.handleChange}>
                          <option value="Mr.">{PROFILE_TEXT.Mr}</option>
                          <option value="Ms.">{PROFILE_TEXT.Ms}</option>
                        </select>
                        {this.state.titleError ? (
                          <div className='alert-danger'>{this.state.titleError}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-5 col-sm-12">
                      <div className={"form-group" + (this.state.first_nameError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.FIRST_NAME} *</label>
                        <input name="first_name" onChange={this.handleChange} maxLength="20" type="text" className="form-control"  />
                        {this.state.first_nameError ? (
                          <div className='alert-danger'>{this.state.first_nameError}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-5 col-sm-12">
                      <div className={"form-group" + (this.state.last_nameError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.LAST_NAME} *</label>
                        <input name="last_name" type="text" onChange={this.handleChange} maxLength="20" className="form-control" />
                        {this.state.last_nameError ? (
                          <div className='alert-danger'>{this.state.last_nameError}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.dobError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.DATE_OF_BIRTH} *</label>
                        <DatePicker
                          className="datePicker form-control"
                          name="dob"
                          selected={this.state.startDate}
                          onChange={this.handleDateChange}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top"
                          autoComplete="off"
                          maxDate={new Date()}
                          onChangeRaw={this.handleDateChangeRaw}
                        />
                        {this.state.dobError ? (
                          <div className='alert-danger'>{this.state.dobError}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.genderError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.GENDER} </label>
                        <select className="form-control" name="gender">
                          <option value={this.state.formData.title=="Mr." ? 'Male' : 'Female'} >{this.state.formData.title=="Mr." ? 'Male' : 'Female'}</option>
                          
                        </select>
                        {this.state.genderError ? (
                          <div className='alert-danger'>{this.state.genderError}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.emailError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.EMAIL} *</label>
                        <input type="text" name="email" onChange={this.handleChange} className="form-control" />
                        {this.state.emailError ? (
                          <div className='alert-danger'>{this.state.emailError}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.phoneError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.PHONE} *</label>
                        <input type="text" name="phone" id="phone" onChange={this.handleChange} maxLength="15" className="form-control" />
                        {this.state.phoneError ? (
                          <div className='alert-danger'>{this.state.phoneError}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="form-btn">
                        <button className="btn" onClick={this.submit}>{PROFILE_TEXT.Submit}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>
        {/* <Footer /> */}
      </React.Fragment>
    );
  }
}

export default Profile;